import { Inject, Injectable, isDevMode } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { Observable, firstValueFrom } from 'rxjs';
import { OktaApp } from '../objects/oktaObj';
import { OidcToken } from '../objects/oidcToken';
import { environment } from '../environments/environment';
import { OKTA_AUTH } from '@okta/okta-angular';
import OktaAuth from '@okta/okta-auth-js';
import { Country } from '../app/shared/country.model';

@Injectable({
  providedIn: 'root',
})
export class OktaFactorService {
  constructor(
    @Inject(OKTA_AUTH) private oktaAuth: OktaAuth,
    private http: HttpClient
  ) {}

  static apiDomain = environment.apiDomain;

  async oktaSend2faSms(
    authenticated: boolean,
    locale?: string,
    userId?: string | null
  ): Promise<any> {
    var postParam: HttpParams = new HttpParams();
    if(userId) {
      postParam = postParam.append("userId", userId);
    }
    if (locale) {
      postParam = postParam.append('locale', locale);
    }
    return firstValueFrom(
      this.http.post(
        OktaFactorService.apiDomain + 'Factor/' + (authenticated ? 'auth/' : '') + 'SendOkta2faSms',
        postParam,
        {
          headers: new HttpHeaders({}),
        }
      )
    );
  }

  async oktaVerify2faSms(authenticated: boolean, code: string, userId?: string | null): Promise<any> {
    var postParam: HttpParams = new HttpParams();
    if(userId) {
      postParam = postParam.append("userId", userId);
    }
    postParam = postParam.append('code', code);
    return firstValueFrom(
      this.http.post(
        OktaFactorService.apiDomain + 'Factor/' + (authenticated ? 'auth/' : '') + 'VerifyOkta2faSms',
        postParam,
        {
          headers: new HttpHeaders({}),
        }
      )
    );
  }

  async oktaSend2faEmail(
    authenticated: boolean,
    locale?: string,
    userId?: string | null
  ): Promise<any> {
    var postParam: HttpParams = new HttpParams();
    if(userId) {
      postParam = postParam.append("userId", userId);
    }
    if (locale) {
      postParam = postParam.append('locale', locale);
    }
    return firstValueFrom(
      this.http.post(
        OktaFactorService.apiDomain + 'Factor/' + (authenticated ? 'auth/' : '') + 'SendOkta2faEmail',
        postParam,
        {
          headers: new HttpHeaders({}),
        }
      )
    );
  }

  async oktaVerify2FaEmail(authenticated: boolean, code: string, userId?: string | null): Promise<any> {
    var postParam: HttpParams = new HttpParams();
    if(userId) {
      postParam = postParam.append("userId", userId);
    }
    postParam = postParam.append('code', code);
    return firstValueFrom(
      this.http.post(
        OktaFactorService.apiDomain + 'Factor/' + (authenticated ? 'auth/' : '') + 'VerifyOkta2faEmail',
        postParam,
        {
          headers: new HttpHeaders({}),
        }
      )
    );
  }

  async removeEmail2fa(): Promise<any> {
    var postParam: HttpParams = new HttpParams();
    // postParam = postParam.append('userId', userId);
    return firstValueFrom(
      this.http.post(
        OktaFactorService.apiDomain + 'Factor/auth/Remove2faEmail',
        postParam,
        {
          headers: new HttpHeaders({}),
        }
      )
    );
  }

  async removeSms2fa(): Promise<any> {
    var postParam: HttpParams = new HttpParams();
    // postParam = postParam.append('userId', userId);
    return firstValueFrom(
      this.http.post(
        OktaFactorService.apiDomain + 'Factor/auth/Remove2faSms',
        postParam,
        {
          headers: new HttpHeaders({}),
        }
      )
    );
  }
}

export interface ApiResponse<T> {
  success: boolean;
  errorMessage: string;
  value: T;
}
